import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


let routes = [];
let bool = 1;

//https://renatello.com/vue-js-password-protect/#Router
//https://stackoverflow.com/questions/45856929/redirect-to-requested-page-after-login-using-vue-router

if(bool){
  routes = [
    {
      path: '/',
      name: 'Admin',
      component: () => import(/* webpackChunkName: "about" */ '../views/Admin.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/protected',
      name: 'Protected',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/Protected.vue')
    },
    {
      path: '/upload',
      name: 'Upload',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/UploadFile.vue')
    },
    {
      path: '/sign-in',
      name: 'Sign In',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackchunkname: "about" */ '../views/SignInScreen.vue')
    },
    {
      path: '/hello-world',
      name: 'hello world',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackchunkname: "about" */ '../views/HelloWorldScreen.vue')
    },
    {
      path: '/table',
      name: 'Table',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/TableScreen.vue')
    },
    {
      path: '/admin',
      name: 'Admin',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/Admin.vue')
    }
  ]
}

const router = new VueRouter({
  routes
})

export default router
